import { render, staticRenderFns } from "./planned-issues-table.vue?vue&type=template&id=0caad708&scoped=true&"
import script from "./planned-issues-table.vue?vue&type=script&lang=js&"
export * from "./planned-issues-table.vue?vue&type=script&lang=js&"
import style0 from "./planned-issues-table.vue?vue&type=style&index=0&id=0caad708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caad708",
  null
  
)

export default component.exports